import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { newRelicConfig } from './environments/newrelic';

/**
 * New Relic Browser Agent — loaded as a polyfill BEFORE zone.js (see angular.json).
 * The agent's SPA feature wraps the global Promise, which must happen before
 * zone.js patches it; hence this runs as a polyfill, not from main.ts.
 *
 * Per-environment values are baked in at build time via fileReplacements
 * (newrelic.ts -> newrelic.<env>.ts). Guarded so a disabled/empty config
 * (e.g. base, or stage/prod placeholders) never breaks app boot.
 */
try {
  const cfg = newRelicConfig;
  if (cfg.enabled && cfg.options?.info?.licenseKey && cfg.options?.info?.applicationID) {
    // Loader executes immediately on instantiation; exposes the global `newrelic` API.
    new BrowserAgent(cfg.options);
  }
} catch (e) {
  // Never let instrumentation break app boot.
  console.warn('[NewRelic] browser agent init skipped:', e);
}
